import React, { useState, useEffect } from "react";
import {
  ArrayInput,
  SimpleFormIterator,
  Edit,
  SimpleForm,
  CardActions,
  ListButton,
  Toolbar,
  SaveButton,
  TextInput,
  required,
  BooleanInput,
} from "react-admin";
import withStyles from "@material-ui/core/styles/withStyles";
import SelectTraining from './Trainings'
import {RichTextInput} from 'ra-input-rich-text';

const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right",
};

const QuestionActions = ({ basePath}) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />

  </CardActions>
);

const QuestionToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="save" redirect="list" submitOnEnter={true} />
  </Toolbar>
);

const answers = [
  {
    id: "a",
    name: "a",
  },
  {
    id: "b",
    name: "b",
  },
  {
    id: "c",
    name: "c",
  },
  {
    id: "d",
    name: "d",
  },
];
const trainingArr = [];


const editStyles = {
  root: { alignItems: "flex-start" },

  inlineBlock: {
    display: "inline-flex",
    marginRight: "8px",
  },
};

const QuestionEdit = ({classes, ...props}) => (
  <Edit {...props}
   actions={<QuestionActions />}>

    <SimpleForm toolbar={<QuestionToolbar />}>
       <SelectTraining  props={props} />
        <TextInput source="exam_name" label="Exam Name" validate={required()} />

        <ArrayInput source="question" label="Question(s)">
        <SimpleFormIterator>
          <RichTextInput
                source='passage'
                label="Passage"
            />
          <TextInput
            source="quest"
            label="Question"
            fullWidth
            formClassName={classes.inlineBlock}
            validate={required()}
          />
         <ArrayInput source="Choices" label="Choice(s)">
          <SimpleFormIterator>
              <TextInput
                source="answer"
                label=""
                fullWidth
                formClassName={classes.inlineBlock}
              />
               <BooleanInput
                source="isAnswere"
                label="Is this an answer?"
                formClassName={classes.inlineBlock}
              />
          </SimpleFormIterator>
          </ArrayInput>
        </SimpleFormIterator>
      </ArrayInput>

        <TextInput
          type="number"
          source="passing_percentage"
          label="Passing Percentage"
          validate={required()}
        />
        <TextInput source="comments" label="Comments" />

      </SimpleForm>
  </Edit>
);

export default withStyles(editStyles)(QuestionEdit);
